import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorModel, GlobalMessageType, HttpErrorHandler, HttpResponseStatus, Priority } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ShimanoForbiddenRequestHandlerService extends HttpErrorHandler {
  responseStatus = HttpResponseStatus.FORBIDDEN;

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleDealerPricePermission(request, response);
  }

  getPriority(): Priority {
    return Priority.HIGH;
  }

  protected getErrors(response: HttpErrorResponse): ErrorModel[] {
    return (response.error.errors || []).filter((error: any) => error.type !== 'JaloObjectNoLongerValidError');
  }

  protected handleDealerPricePermission(request: HttpRequest<any>, response: HttpErrorResponse) {
    this.getErrors(response)
      .filter((error) => error.type === 'ShimanoStoreFrontPermissionError')
      .forEach((error) => {
        this.globalMessageService.add(error.message, GlobalMessageType.MSG_TYPE_ERROR);
      });
  }
}
